var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('canvas',{ref:"signatureCanvas",attrs:{"width":"500","height":"300"}}),_vm._v(" "),_c('button',{on:{"click":_vm.clear}},[_vm._v("Clear")]),_vm._v(" "),_c('button',{on:{"click":_vm.save}},[_vm._v("Save")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b59587ee","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/kneexpert/TabComplain.vue
// module id = null
// module chunks = 